import { RouteRecordRaw } from 'vue-router'

const log: Array<RouteRecordRaw> = [{
    path: '/log',
    meta: {
        title: "日志管理"
    },
    component: () => import("@/views/log.vue")
}];
export default log;